/* TWIST — global.js (vanilla, no dependencies) */
(function () {
  'use strict';

  /* ---------- mobile menu ---------- */
  function setMenu(open) {
    var nav = document.querySelector('[data-menu-drawer]');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-menu-drawer]');
      setMenu(nav && !nav.classList.contains('is-open'));
      return;
    }
    if (e.target.closest('[data-menu-drawer] a')) setMenu(false);
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 640) setMenu(false);
  });

  /* ---------- scroll reveals ---------- */
  function revealEl(el) { el.classList.add('in'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { revealEl(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    /* safety net: reveal anything already in view shortly after load */
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) revealEl(el);
        });
      }, 400);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(revealEl);
  }

  /* ---------- money formatting (Shopify money_format string) ---------- */
  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function delimit(number, thousands, decimal, precision) {
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    switch ((format.match(placeholder) || [, 'amount'])[1]) {
      case 'amount_no_decimals': value = delimit(cents, ',', '.', 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, '.', ',', 0); break;
      default: value = delimit(cents, ',', '.', 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- toast + multi-item ajax add ---------- */
  var toastTimer;
  function showToast(name) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    var label = toast.querySelector('[data-toast-name]');
    if (label) label.textContent = name;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }
  function addItems(items, name) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Error');
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        showToast(name);
      });
  }

  /* ---------- shop the capsule: buy the set or pick pieces ---------- */
  document.querySelectorAll('[data-capsule]').forEach(function (section) {
    var moneyFormat = section.getAttribute('data-money-format') || '{{amount}}';
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-cap-item]'));
    var countEl = section.querySelector('[data-cap-count]');
    var totalEl = section.querySelector('[data-cap-total]');
    var addSel = section.querySelector('[data-add-selected]');
    var addSet = section.querySelector('[data-add-set]');

    function selected() {
      return items.filter(function (i) { return i.classList.contains('sel'); });
    }
    function refresh() {
      var sel = selected();
      var total = sel.reduce(function (s, i) { return s + parseInt(i.getAttribute('data-price'), 10); }, 0);
      if (countEl) countEl.textContent = sel.length;
      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      if (addSel) {
        addSel.disabled = sel.length === 0;
        var tpl = sel.length
          ? addSel.getAttribute('data-label-count')
          : addSel.getAttribute('data-label-default');
        addSel.textContent = (tpl || '')
          .replace('[count]', sel.length)
          .replace('[total]', formatMoney(total, moneyFormat));
      }
    }
    function resetSelection() {
      items.forEach(function (i) {
        i.classList.remove('sel');
        var btn = i.querySelector('[data-cap-pick]');
        if (btn && !btn.disabled) btn.textContent = btn.getAttribute('data-label-select');
      });
      refresh();
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-cap-pick]');
      if (!btn || btn.disabled) return;
      btn.addEventListener('click', function () {
        var on = item.classList.toggle('sel');
        btn.textContent = btn.getAttribute(on ? 'data-label-selected' : 'data-label-select');
        refresh();
      });
    });

    if (addSel) {
      addSel.addEventListener('click', function () {
        var sel = selected();
        if (!sel.length) return;
        addSel.disabled = true;
        addItems(
          sel.map(function (i) { return { id: parseInt(i.getAttribute('data-variant-id'), 10), quantity: 1 }; }),
          addSel.getAttribute('data-toast-name').replace('[count]', sel.length)
        )
          .then(resetSelection)
          .catch(function () { addSel.disabled = false; });
      });
    }

    if (addSet) {
      addSet.addEventListener('click', function () {
        var ids = (addSet.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        addSet.disabled = true;
        addItems(
          ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }),
          addSet.getAttribute('data-set-name')
        )
          .then(resetSelection)
          .finally(function () { addSet.disabled = false; });
      });
    }

    refresh();
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var next = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product form: variant selection ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsScript = document.querySelector('[data-product-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var idInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var atcBtn = productForm.querySelector('[data-atc-button]');
    var atcLabel = atcBtn ? atcBtn.getAttribute('data-label-add') : '';
    var soldOutLabel = atcBtn ? atcBtn.getAttribute('data-label-sold-out') : '';

    function currentOptions() {
      var opts = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    productForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var variant = findVariant(currentOptions());
      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = soldOutLabel; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? atcLabel : soldOutLabel;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });

    /* ---------- add to cart (ajax) ---------- */
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn) atcBtn.disabled = true;
      var status = document.querySelector('[data-atc-status]');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(idInput.value, 10), quantity: parseInt((productForm.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1 }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Error');
          if (status) { status.textContent = status.getAttribute('data-success'); status.hidden = false; }
          return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function (err) {
          if (status) { status.textContent = err.message; status.hidden = false; }
        })
        .finally(function () {
          if (atcBtn) atcBtn.disabled = false;
        });
    });
  }

  /* ---------- cart page: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-form] [data-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });
})();
